const servidores_id={
        18: "SERVIDORES - GEMYC",
        19: "SERVIDORES - BOTONES",
        17: "SERVIDORES - CAD",
        10: "SERVIDORES - GENETEC",
}




const roles={
        "message": "success",
        "success": true,
        "data": [
          {
            "rol_id": 1,
            "name": "admin",
            "created_at": "NaT",
            "permissions": [
              {
                "permission_id": 1,
                "module_name": "filters",
                "name": "read"
              },
              {
                "permission_id": 2,
                "module_name": "filters",
                "name": "write"
              }
            ],
            "id": 1
          },
          {
            "rol_id": 2,
            "name": "prueba",
            "created_at": "NaT",
            "permissions": [
              {
                "permission_id": 1,
                "module_name": "filters",
                "name": "read"
              }
            ],
            "id": 2
          },
          {
            "rol_id": 5,
            "name": "Admin",
            "created_at": "2023-08-24T17:26:07",
            "permissions": [
              {
                "permission_id": 1,
                "module_name": "filters",
                "name": "read"
              }
            ],
            "id": 5
          },
          {
            "rol_id": 6,
            "name": "Admin",
            "created_at": "2023-08-24T17:26:29",
            "permissions": [
              {
                "permission_id": 1,
                "module_name": "filters",
                "name": "read"
              }
            ],
            "id": 6
          },
          {
            "rol_id": 7,
            "name": "rol 1",
            "created_at": "2024-03-06T06:35:49",
            "permissions": [
              {
                "permission_id": 6,
                "module_name": "buzon",
                "name": "buzon"
              },
              {
                "permission_id": 8,
                "module_name": "monitoreo",
                "name": "monitoreo"
              }
            ],
            "id": 7
          },
          {
            "rol_id": 8,
            "name": "Rol 1",
            "created_at": "2024-03-06T06:36:48",
            "permissions": [
              {
                "permission_id": 6,
                "module_name": "buzon",
                "name": "buzon"
              },
              {
                "permission_id": 8,
                "module_name": "monitoreo",
                "name": "monitoreo"
              }
            ],
            "id": 8
          }
        ],
        "status_code": 200
      }
      
const permisos_codigo_id={
      'reportes':3,
      'CMDB':4,
      'acciones':5,
      'buzon':6,
      'admin':7,
      'monitor':8,
      'consola':9,
      'acciones_host':10,
      'acknownledge':11,
      'servidores_10':12,
      'servidores_19':14,
      'servidores_17':13,
      'servidores_18':15,
      'link_ticket':16,
      'RESET mapa':17,
      'mantenimiento':18,
      'portafolio':19,
      'configuracion':20,
      'mapa':21,
      'panel eventos':22,
      'panel dispositivos':23,
      'panel grupos':24,
      'respaldo':25,
      'encuestas':26,
      'workflow':27,
      'provicionamiento':28,
"agencias": 29,
"criticidades de dispositivos": 30,
"grupos de dispositivos": 31,
"nodos de monitoreo": 32,
"dispositivos": 33,
"correlacion dispositivos": 34,
"tecnologías": 35,
"marcas": 36,
"modelos": 37,
"mediciones": 38,
"disparadores": 39,
"eventos": 40,
"medios de difusión": 41,
"auditor": 42,
"lista tecnologías": 43,
"ODD": 44,
"ALPR": 45,
"AP´S": 46,
"BD": 47,
"FIJAS": 48,
"PTP": 49,
"ENLACES AVIAT": 50,
"TELEFONIA - ISSABEL": 51,
"PTZ": 52,
"RFID": 53,
"SERVIDORES - GENETEC": 54,
"SUSCRIPTORES": 55,
"RUTEADORES": 56,
"SWITCH PMI": 57,
"SWITCH CORE": 58,
"TELEFONIA - VOIP": 59,
"SERVERS": 60,
"SERVIDORES - CAD": 61,
"TELEFONIA - NAS": 62,
"TELEFONIA": 63,
"SWITCH TORRE": 64,
"SWITCH ACCESO": 65,
"RESET": 66,
"INTERCOM": 67,
"PMV": 68,
"PANTALLAS": 69,
"GRABADORES": 70,
"BH": 71,
"BACKHAUL":90,
'General':72,
"crear dispositivo": 73,
"eliminar dispositivo": 74,
"editar dispositivo": 75,
"crear marca": 76,
"eliminar marca": 77,
"editar marca": 78,
"crear modelo": 79,
"eliminar modelo": 80,
"editar modelo": 81,
"flujo de trabajo": 82,
"flujo de acciones": 83,
"crear workflow": 84,
"eliminar workflow": 85,
"editar workflow": 86,
'Registros':87,
'panel resets':88,
"Buzon Grupos": 90,
"crear cis": 91,
'editar cis':92,
'eliminar cis':93,
'cis':94,
'mapa afilicion':95,
"INVENGO": 501,
"BT CATCHER": 502,
"REMOLQUES": 503,
"SERVIDORES":504,
  "ARCOS": 505,
  "PMI RESGUARDO": 506,
  "BIOMETRICOS": 507,
  "WORKSTATION": 508,
  "UPS": 509,
  "FILTRO": 510,
  "FIREWALL": 511,
  "ACCESS POINT": 512,
  "SWITCH CORE SERVIDORES": 513,
  "SERVIDORES ISSABEL": 514,
  "MEDIA GATEWAY": 515,
  "TELEFONIA - TELMEX":516,
    "SWITCH ARCO":602 ,
    "PC DE ARCO":603,
   "SERVIDOR CCTV":605,
   "SERVIDOR ARCO":606,
   "SERVIDOR LPR":607,
   "PANTALLA DE ARCO":608,
   "OMODA":609,
   "admin_update_password": 1000
}


      export  {servidores_id,roles,permisos_codigo_id}